export default "__VITE_ASSET__CU5Xzk3s__"